// project import
import dashboard from './dashboard';
import support from './support';
import simulacao from './simulacao';
import consultaMassiva from './consultaMassiva';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [simulacao, dashboard, support, consultaMassiva]
};

export default menuItems;
